import { addDoc, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { inputCategoriesRef, InputCategory } from '@api/InputCategories/InputCategory';
import { publishCatalog } from '@api/Catalog/CatalogVersion';
import { buildCreationStamp } from '@api/ActivityLogs/CreationStamp';
import { INPUT_CATEGORY_FIELDS, logCatalogChange } from '@api/ActivityLogs/CatalogActivity';

export default {
    async saveInputCategory(inputCategory: InputCategory): Promise<InputCategory> {
        const inputCategoryExist = await this.getInputCategoryByName(inputCategory.name);
        if (inputCategoryExist) {
            throw new Error('Categoría de insumo existente.');
        }
        const isNew = !inputCategory.id;
        const before = isNew ? null : await this.getInputCategory(inputCategory.id as string);
        if (isNew) {
            const data = await addDoc(inputCategoriesRef, { ...inputCategory, ...(await buildCreationStamp()) });
            inputCategory.id = data.id;
        }
        await updateDoc(doc(inputCategoriesRef, inputCategory.id), { ...inputCategory });
        await logCatalogChange('input-category', inputCategory.id, before, inputCategory, INPUT_CATEGORY_FIELDS);
        // ⚠️ Estaba OLVIDADO hasta el 2026-09-09: la categoría viaja DESNORMALIZADA
        // dentro de cada insumo (`inputCategoryData`), así que renombrarla sin
        // republicar dejaba el nombre viejo en el catálogo de todos.
        await publishCatalog('input-category');
        return inputCategory;
    },
    async getInputCategories(): Promise<InputCategory[]> {
        const inputCategories: InputCategory[] = [];
        const queryDoc = query(inputCategoriesRef);
        const snapshot = await getDocs(queryDoc);
        if (snapshot.empty) {
            return inputCategories;
        }
        snapshot.docs.map((doc: any) => {
            // El id va explícito: `doc.data()` no lo incluye y el mapa por id de
            // `InputServ.getInputs` lo necesita para resolver la categoría.
            inputCategories.push({ ...(doc.data() as InputCategory), id: doc.id });
        });
        return inputCategories;
    },
    async getInputCategory(inputCategoryId: string): Promise<InputCategory> {
        const documentData = await getDoc(doc(inputCategoriesRef, inputCategoryId));
        return documentData.data() as InputCategory;
    },
    async getInputCategoryByName(name: string): Promise<InputCategory | undefined> {
        let inputCategory = undefined;
        const queryInputCategory = query(inputCategoriesRef, where('name', '==', name));
        const snapshot = await getDocs(queryInputCategory);
        if (snapshot.empty) {
            return inputCategory;
        }
        snapshot.forEach((doc: any) => {
            inputCategory = doc.data() as InputCategory;
        });
        return inputCategory;
    },
    async deleteInputCategory(inputCategoryId: string): Promise<void> {
        await deleteDoc(doc(inputCategoriesRef, inputCategoryId));
        await publishCatalog('input-category-delete');
        return;
    }
};
